// extracted by mini-css-extract-plugin
module.exports = {"Error":"ErrorPage_Error__3fVA7","container":"ErrorPage_container__QjHm7","buttons":"ErrorPage_buttons__3KSel"};